// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__-SR4z","iconContainer":"Footer_iconContainer__w6014"};